import { createContext, useContext, useState } from "react";
import { requestWithToken } from "../utils/apis";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState({});
  const token = localStorage.getItem("token");
  if (token && !isAuthenticated) {
    setIsAuthenticated(true);
  }

  const fetchUserDetails = async () => {
    const result = await requestWithToken("GET", "/api/user/me");
    console.log(result, "res")
    if (result?.data?.status === 0) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return;
    }
    if (result?.status === 200) {
      setUser(result.data.data);
    }
  };

  const login = () => {
    fetchUserDetails()
    setIsAuthenticated(true)
  };
  const logout = () => {
    setIsAuthenticated(false)
    localStorage.removeItem("token")
  };


  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
